<div class="stick-top">
  <mat-toolbar><mat-icon>local_activity</mat-icon> Ticket Approvals</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/ticketApprovals/0">
      <mat-icon aria-label="Create a new Ticket Approval">add</mat-icon>
      Create a new Ticket Approval
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
        </div>
      </th>
      <th><div class="vbox">Name<input [(ngModel)]="filter.name"></div></th>
      <th><div class="vbox">Event Category<input [(ngModel)]="filter.eventCategory"></div></th>
      <th><div class="vbox">Event Type<input [(ngModel)]="filter.eventType"></div></th>
      <th><div class="vbox">Contact Group<input [(ngModel)]="filter.contactGroup"></div></th>
      <th><div class="vbox">Active<input [(ngModel)]="filter.active"></div></th>
      <th><div class="vbox">approvalOrder<input [(ngModel)]="filter.approvalOrder"></div></th>
      <th><div class="vbox">Notes<input [(ngModel)]="filter.notes"></div></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <td><a routerLink="/ticketApprovals/{{element.id}}">{{element.name}}</a></td>
      <td>{{element.eventCategoryName}}</td>
      <td>{{element.eventTypeName}}</td>
      <td>{{element.contactGroupName}}</td>
      <td>{{element.active}}</td>
      <td>{{element.approvalOrder}}</td>
      <td>{{element.notes}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0"><td colspan="100"><em>No results found</em></td></tr>
    </tbody>
    <tfoot><tr><td colspan="100">
      <mat-paginator #paginator (page)="reload()"></mat-paginator>
    </td></tr></tfoot>
  </table>
</div>
